import { AppContext } from "../../../AppContext";

/**
 * Global (non per-reader) settings for the DocumentProtection module.
 *
 * The per-email `readers` / `defaults` configuration this file used to resolve
 * has been removed: protection is now driven entirely by the RShield options
 * the SENDER selects per document on the Send / Generate tab (see
 * rShieldConfig.js). All that remains here is the emergency kill-switch and
 * the optional audit endpoint.
 */

/**
 * Master kill-switch. When false, RShield is inert in the reader for every
 * document regardless of what the sender configured.
 */
export function isProtectionEnabled() {
  try {
    const cfg = AppContext && AppContext.DocumentProtection;
    // Default to enabled when the block is missing entirely.
    return !cfg || cfg.enabled !== false;
  } catch (e) {
    // Never let a config error break the reader - fail open on the switch and
    // let the document's own RShield flag decide.
    return true;
  }
}

/** Optional endpoint audit events are POSTed to ("" = console only). */
export function getAuditApiUrl() {
  try {
    const cfg = AppContext && AppContext.DocumentProtection;
    return (cfg && cfg.auditApiUrl) || "";
  } catch (e) {
    return "";
  }
}

export default isProtectionEnabled;
